module.exports = "<i\n  data-toggle=\"tooltip\"\n  ng-attr-title=\"Click for more information\"\n  data-placement=\"bottom\"\n  style=\"color: #62c046; margin-right: 5px\"\n  ng-click=\"vm.scrollToToolTip()\"\n  class=\"paj-tooltip far fa-lightbulb\"\n/>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/pajtooltip/pajtooltip.html
// module id = 250
// module chunks = 0